const updateItems = [
  {
    date: '2026-07-28',
    title: '【更新】热血江湖：风云再起 第186话',
    desc: '主角突破最终境界，与宿敌展开惊天动地的终极对决',
    tag: '最新章节',
  },
  {
    date: '2026-07-28',
    title: '【更新】异界幻想：元素使者 第215话',
    desc: '第六元素之力完全觉醒，全新的战斗形态惊艳登场',
    tag: '最新章节',
  },
  {
    date: '2026-07-27',
    title: '【更新】甜蜜陷阱：恋爱百分百 第132话',
    desc: '校草的告白计划终于付诸行动，全校炸开了锅',
    tag: '最新章节',
  },
  {
    date: '2026-07-27',
    title: '【上新】校园日常：青春日记 正式上线',
    desc: '全新校园题材漫画上线，讲述一群高中生的欢乐日常故事',
    tag: '新作上线',
  },
  {
    date: '2026-07-26',
    title: '【更新】暗夜追踪：深渊之眼 第98话',
    desc: '凶手身份揭晓，整个案件的真相令人不寒而栗',
    tag: '最新章节',
  },
  {
    date: '2026-07-26',
    title: '【公告】羞羞歪歪漫画APP v3.2版本发布',
    desc: '优化下拉式竖屏阅读体验，新增夜间模式和智能缓存功能',
    tag: '系统公告',
  },
  {
    date: '2026-07-25',
    title: '【完结】古风奇缘：千年之约 大结局',
    desc: '千年虐恋终有结果，感人至深的结局让无数读者落泪',
    tag: '已完结',
  },
  {
    date: '2026-07-25',
    title: '【更新】都市传说：午夜画室 第67话',
    desc: '主角进入画中世界，诡异的异空间冒险正式开始',
    tag: '最新章节',
  },
  {
    date: '2026-07-24',
    title: '【上新】电竞之王：巅峰之路 正式连载',
    desc: '热血电竞题材全新上线，跟随主角征战职业赛场',
    tag: '新作上线',
  },
];

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-16 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-heading text-foreground-900 text-center mb-10">
          更新动态
        </h2>
        <div className="max-w-3xl mx-auto">
          <div className="relative pl-8 border-l-2 border-background-300/60">
            {updateItems.map((item, i) => (
              <div key={i} className="relative pb-8 last:pb-0">
                <div className="absolute -left-[25px] top-0 w-3 h-3 rounded-full bg-primary-500 ring-4 ring-background-100"></div>
                <div className="bg-background-50 rounded-xl p-5 border border-background-200/70 hover:border-primary-200/50 transition-all cursor-pointer">
                  <div className="flex flex-wrap items-center gap-3 mb-2">
                    <span className="text-xs text-foreground-500">{item.date}</span>
                    <span
                      className={`px-2 py-0.5 rounded-md text-xs font-medium whitespace-nowrap ${
                        item.tag === '最新章节'
                          ? 'bg-accent-100 text-accent-700'
                          : item.tag === '新作上线'
                          ? 'bg-primary-100 text-primary-700'
                          : item.tag === '已完结'
                          ? 'bg-secondary-100 text-secondary-700'
                          : 'bg-background-200 text-foreground-600'
                      }`}
                    >
                      {item.tag}
                    </span>
                  </div>
                  <h3 className="text-sm font-medium text-foreground-900 mb-1.5">{item.title}</h3>
                  <p className="text-sm text-foreground-600 leading-relaxed">{item.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}